import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a view for the deposit report table.
 * @extends JetView
 */
export default class recordTableDepositReportView extends JetView {
    /**
     * Configures the datatable for displaying deposit report data.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Defines the view type
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enables row selection
            height: 200, // Sets the height of the datatable
            columns: [
                // Defines the columns of the datatable
                { id: 'Date', header: 'Fecha', width: 150, sort: 'int' }, // Date column
                { id: 'UserId', header: 'ID Usuario', width: 100, sort: 'int' }, // User ID column
                {
                    id: 'TransactionId',
                    header: 'Transacción ID',
                    width: 100,
                    sort: 'int', // Transaction ID column
                },
                {
                    id: 'Description',
                    header: 'Descripción',
                    width: 300,
                    sort: 'int', // Description column
                },
            ],
            pager: 'pagerA', // Pager configuration
            url: devConfig.geturlApi() + 'es/Financial/GetDepositsDetail', // API endpoint for data loading
        };
    }

    /**
     * Initializes the view and sets up event listeners for filtering and loading data.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        var url = grid.data.url; // Stores the URL for data loading
        this.on(this.app, 'depositReport:filter', (filterData) => {
            // Event listener for filtering data
            var object = Object.entries(filterData); // Converts filter data to entries
            var string1 = ''; // Initializes query string for filters
            for (var i = 0; i < object.length; i++) {
                // Iterates through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Checks for non-object filters
                    if (object[i][0] == 'Datepicker') {
                        // Special handling for date range
                        var date = object[i][1].split(' - '); // Splits date range
                        console.log(date); // Logs the date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Adds start date to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Adds end date to query string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Adds other filters to query string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handles object type filters
                        var object2 = Object.entries(object[i][1]); // Converts object filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterates through object entries
                            if (object2[j][1] !== null) {
                                // Checks for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handles start date
                                    var d = new Date(object2[j][1]); // Creates date object
                                    var dateFrom = // Formats start date for query string
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Adds formatted start date to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handles end date
                                        var d = new Date(object2[j][1]); // Creates date object
                                        var dateTo = // Formats end date for query string
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Adds formatted end date to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clears existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Loads filtered data into the grid
        });
        this.on(this.app, 'deposit:id', (Id) => {
            // Event listener for loading data by deposit ID
            grid.clearAll(); // Clears existing data in the grid
            grid.load(url + '?id=' + Id); // Loads data for the specified deposit ID
        });
    }
}

// FILE DOCUMENTED
